import { orderBy, uniqBy } from 'lodash-es'
import eboInstance from './ebo'
import { isItemId } from './rarible'
import { clearCache } from './algolia'
import { CHAIN_ID } from '~/utils/constants'
import { lowercaseObjectID } from '~/utils/helpers'

export const add = async (itemId) => {
  try {
    if (!isItemId(itemId)) throw new Error('Invalid itemId')
    const res = await eboInstance({
      method: 'post',
      url: `/augmintables/${lowercaseObjectID(itemId)}`,
    })
    await clearCache()
    return res
  } catch (e) {
    console.error(`Failed Adding Augmintable ${itemId}`, e)
    throw e
  }
}

export const update = async (itemId) => {
  try {
    if (!isItemId(itemId)) throw new Error('Invalid itemId')
    const res = await eboInstance({
      method: 'put',
      url: `/augmintables/${itemId}`,
    })
    await clearCache()
    return res
  } catch (e) {
    console.error(`Failed Updating Augmintable ${itemId}`, e)
    throw e
  }
}

export const saveAsset = async (data, type, recaptcha) => {
  try {
    if (!type) throw new Error('Unknown type')
    if (!recaptcha) throw new Error('Unknown recaptcha')
    if (data instanceof File) {
      const formData = new FormData()
      formData.append('file', data)
      formData.append('type', type)
      formData.append('chainId', CHAIN_ID)
      formData.append('recaptcha', recaptcha)
      const res = await eboInstance({
        method: 'post',
        url: `/ipfs/add/`,
        data: formData,
        headers: { 'Content-Type': 'multipart/form-data' },
        timeout: 5 * 60 * 1000,
      })
      console.info({ fileIPFS: res })
      if (!res.data) throw new Error(`Missing response data uploading File`)
      return res.data
    } else {
      const res = await eboInstance({
        method: 'post',
        url: `/ipfs/add/`,
        data: { ...data, chainId: CHAIN_ID, type, recaptcha },
        headers: { 'Content-Type': 'application/json' },
      })
      console.info({ metaIPFS: res })
      if (!res.data) throw new Error(`Missing response data uploading JSON`)
      return res.data
    }
  } catch (e) {
    console.error(`Failed saving Augmintables file`, e)
    throw e
  }
}

export const get = async (itemId) => {
  try {
    if (!isItemId(itemId)) throw new Error('Invalid itemId')
    const { data } = await eboInstance({
      method: 'get',
      url: `/augmintables/${itemId}`,
    })
    return data
  } catch (e) {
    console.error(`Failed Getting Augmintable ${itemId}`, e)
    throw e
  }
}

export const getHistory = async (itemId) => {
  try {
    if (!isItemId(itemId)) throw new Error('Invalid itemId')
    const { data } = await eboInstance({
      method: 'get',
      url: `/augmintables/${itemId}/history`,
    })
    const unique = uniqBy(data, (event) => event['@type'] + event.transactionHash)
    return orderBy(unique, (event) => new Date(event.date).getTime(), 'desc')
  } catch (e) {
    console.error(`Failed Getting Augmintable History ${itemId}`, e)
    throw e
  }
}

export const getBlocklist = async () => {
  try {
    const { data } = await eboInstance({
      method: 'get',
      url: `/augmintables/blocklist`,
      params: { chainId: CHAIN_ID },
    })
    return data
  } catch (e) {
    console.error('Failed Getting blocklist', e)
    return { profiles: [], augmintables: [] }
  }
}

export const getFeatured = async () => {
  try {
    const { data } = await eboInstance({
      method: 'get',
      url: `/augmintables/featured`,
    })
    return data
  } catch (e) {
    console.error('Failed Getting featured augmintable', e)
    return {}
  }
}
